(function(){
     'use strict';

     angular
        .module('app')
        .factory('AnalisisService', AnalisisService);

    AnalisisService.$inject = ['$http'];

    function AnalisisService($http){

        var service= {
           getHistAnalisisCentro:getHistAnalisisCentro,
           getAnaliticaByMuestraId:getAnaliticaByMuestraId,
           guardarPeticion:guardarPeticion,
           getAnaliticasByMuestra:getAnaliticasByMuestra,
           getReglas:getReglas,
           getAnaliticasCategoria:getAnaliticasCategoria,
           getAnaliticasPerfil:getAnaliticasPerfil,
           guardarAsesoramiento:guardarAsesoramiento,
           cambiarPaciente:cambiarPaciente,
           getAnaliticaByRecomendacion:getAnaliticaByRecomendacion,
           getInfoVacunas:getInfoVacunas,
           getInfoVacunasChecked :getInfoVacunasChecked,
           getTransporte:getTransporte,
           getInfoCitologia:getInfoCitologia,
           base64toimg:base64toimg
           
        };

        return service;

        function base64toimg(filename,base64,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
                ignoreLoadingBar: true, 
            }

            var data = $.param({
               ignoreLoadingBar: true, 
               base64:base64,
               filename:filename,
               lang_id:lang_id
            });
            $http.post('/uranolab/base64toimg', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
        function getInfoCitologia(callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getinfocitologia', { params : { lang_id:lang_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
 		function getHistAnalisisCentro(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/gethistanalisiscentro', { params : { lang_id:lang_id,filtros : filtros }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getTransporte(sumaCarrito,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/gettransporte', { params : { lang_id:lang_id,sumaCarrito : sumaCarrito }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getInfoVacunasChecked(peticion_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getinfovacunaschecked', { params : { peticion_id:peticion_id, lang_id:lang_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getInfoVacunas(extra,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getinfovacunas', { params : { extra:JSON.stringify(extra), lang_id:lang_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnaliticaByRecomendacion(rec_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanaliticasbyrecomendacion', { params : { lang_id:lang_id,rec_id : rec_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        function cambiarPaciente(animal_id,muestra_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               muestra_id:muestra_id,
               animal_id:animal_id,
               lang_id:lang_id
            });
            $http.post('/uranolab/cambiarpacientepeticion', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }


        function guardarAsesoramiento(muestra_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               muestra_id:muestra_id,
               lang_id:lang_id
            });
            $http.post('/uranolab/guardarasesoramiento', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        
        function getAnaliticasPerfil(analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanaliticasbyperfil', { params : { lang_id,lang_id,analitica_id:analitica_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

         function getAnaliticasCategoria(carrito,animal,categoria,buscador,centro_id,muestraSeleccionada,paramsExtra,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanaliticascategoria', { params : { paramsExtra:JSON.stringify(paramsExtra), muestra:(muestraSeleccionada.id ? muestraSeleccionada.id : ''), carrito:JSON.stringify(carrito),animal_id:animal.id,centro_id:centro_id,lang_id:lang_id,categoria : JSON.stringify(categoria),buscador:buscador }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getReglas(carrito,centro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getreglas', { params : { centro:centro,carrito : JSON.stringify(carrito) }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getAnaliticasByMuestra(muestra_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanaliticasbymuestra', { params : { lang_id:lang_id, muestra_id : muestra_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        function guardarPeticion(carrito,fields,muestrasSeleccionadas,animal_id,alt_muestra_id,paramsExtra,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               fields:angular.toJson(fields),
               carrito:angular.toJson(carrito),
               muestrasSeleccionadas:angular.toJson(muestrasSeleccionadas),
               animal_id:animal_id,
               alt_muestra_id:alt_muestra_id,
               lang_id:lang_id,
               paramsExtra: JSON.stringify(paramsExtra),
            });
            $http.post('/uranolab/guardarpeticion', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getAnaliticaByMuestraId(muestra_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getmuestrabyid', { params : { muestra_id : muestra_id, lang_id:lang_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

    }
})();